import React from 'react'

import { BaseContent } from '@fourthwall/components'

import * as S from './LoginPlatform.styled'

type LoginPlatformProps = {
  image: string
  provider: string
  username: string
}

export const LoginPlatform = ({ image, provider, username }: LoginPlatformProps) => (
  <S.Container>
    <div>
      <S.ProviderImage src={image} alt={provider} />
    </div>
    <div>
      <BaseContent>
        <strong>{provider}</strong>
      </BaseContent>
    </div>
    <S.Username>
      <BaseContent appearance="secondary" size="small">
        {username}
      </BaseContent>
    </S.Username>
  </S.Container>
)
